export default __webpack_public_path__ + "static/img_we_2@2x-bf8adda66a06f996ff750c07d8a31954.png";